var a=new Map,e=new Map,p=new Map,n=new Map;export{a as st,e as ts,p as simplifiedPhrasesMap,n as traditionalPhrasesMap};